// extracted by mini-css-extract-plugin
export default {"root":"Q6rk2sSY8OnjYFf7FqIg","dark":"qfNg1Uxa9lGkTN8QIavt","tagCount":"BjXoNjpNwhcIghtLZHzk"};